'use strict';

/**
 * View for rendering the sets for the drag and drop
 *
 * @category   View
 * @module     entities
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var CompositeView = require('base/Colido.CompositeView');
var NavigationSetsItemView = require('./navigation-sets-dnd-list-item');

var template = require('../../templates/partials/navigation-sets-dnd-list.hbs');

var NavigationSetsDndListView = CompositeView.extend({
    template: template,

    childView: NavigationSetsItemView,

    childViewContainer: '#navigationSetsList',

    collectionEvents: {
        'add remove reset sync': 'render',
    },
});

module.exports = NavigationSetsDndListView;